import request from 'superagent';
import authBearer from '~/core/utils/authBearer';
import {BASE_URL, BASE_REQ_HEADERS} from '~/config/endpoints';

/**
 * Auth Services
 *
 */
export default class AuthServices {
	static async getUserDetails() {
		const response = await request
			.get(`${BASE_URL.user}/v2/portal/workersInsurance/me`)
			.set(BASE_REQ_HEADERS)
			.use(authBearer);
		return response.body.data;
	}

	static async patchUserDetails(payload) {
		const response = await request
			.patch(`${BASE_URL.user}/v2/portal/workersInsurance/me`)
			.send(payload)
			.set(BASE_REQ_HEADERS)
			.use(authBearer);

		return response.status === 200;
	}
}
